import * as React from 'react';
export var AffordableCleanEnergy = function (_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "48",
    height: "48",
    viewBox: "0 0 576.2 604"
  }, React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
    transform: "translate(80.000000, 66.111340)"
  }, React.createElement("path", {
    fill: "#FAB700",
    d: "M208.6,386.6c-30.5,0-55.3-24.8-55.3-55.4c0-24.9,16.3-45.9,38.9-52.9v20.6\n        c-11.7,6-19.8,18.2-19.8,32.3c0,20,16.2,36.3,36.2,36.3s36.2-16.2,36.2-36.3c0-14.1-8.1-26.3-19.9-32.3v-20.6\n        c22.6,7,39,28,39,52.9C263.9,361.8,239.1,386.6,208.6,386.6z M200.7,267.6c0-3.5,3.6-7.4,7.9-7.4c4.4,0,7.9,3.9,7.9,7.4v36.6\n        c0,3.5-3.5,7.4-7.9,7.4s-7.9-3.9-7.9-7.4V267.6z M208.6,225.5c-58.7,0-106.3,47.7-106.3,106.5s47.6,106.5,106.3,106.5\n        S314.9,390.8,314.9,332C314.9,273.2,267.3,225.5,208.6,225.5z"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M86.5,331.1c0-4.8-4.3-8.7-8.2-8.7H31.7c-3.9,0-8.2,3.9-8.2,8.7c0,4.8,4.3,8.8,8.2,8.8h46.6\n        C82.2,339.8,86.5,335.9,86.5,331.1"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M393.6,331.1c0-4.8-4.3-8.7-8.2-8.7h-46.6c-3.9,0-8.2,3.9-8.2,8.7c0,4.8,4.3,8.8,8.2,8.8\n        h46.6C389.4,339.8,393.6,335.9,393.6,331.1"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M208.6,516.4c4.8,0,8.7-4.3,8.7-8.2v-46.6c0-3.9-3.9-8.2-8.7-8.2c-4.8,0-8.8,4.3-8.8,8.2\n        v46.6C199.8,512.1,203.8,516.4,208.6,516.4"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M369.2,423.1c2.4-4.2,0.6-9.7-2.8-11.6L326,388.3c-3.4-2-9.1-0.7-11.5,3.5\n        s-0.6,9.8,2.8,11.7l40.4,23.2C361.1,428.6,366.8,427.3,369.2,423.1"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M116.7,491.9c4.2,2.4,9.7,0.6,11.6-2.8l23.1-40.5c2-3.4,0.7-9.1-3.5-11.5s-9.7-0.6-11.7,2.8\n        l-23.1,40.5C111.2,483.8,112.5,489.5,116.7,491.9"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M300.8,491.7c4.2-2.4,5.4-8.1,3.5-11.4l-23.2-40.4c-2-3.4-7.5-5.2-11.7-2.8\n        c-4.2,2.4-5.4,8.1-3.5,11.5l23.2,40.4C291.1,492.4,296.7,494.1,300.8,491.7"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M48.2,423.5c2.4,4.2,8,5.4,11.4,3.5l40.4-23.2c3.4-2,5.2-7.5,2.8-11.7s-8.1-5.5-11.5-3.5\n        l-40.4,23.2C47.5,413.7,45.8,419.3,48.2,423.5"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M208.6,208.8c4.8,0,8.7-4.3,8.7-8.2V154c0-3.9-3.9-8.2-8.7-8.2c-4.8,0-8.8,4.3-8.8,8.2v46.6\n        C199.8,204.6,203.8,208.8,208.6,208.8"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M102.6,270.4c2.4-4.2,0.6-9.7-2.8-11.6l-40.4-23.2c-3.4-2-9.1-0.7-11.5,3.5\n        c-2.4,4.2-0.6,9.8,2.8,11.7L91.1,274C94.6,275.8,100.2,274.6,102.6,270.4"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M269.2,225c4.2,2.4,9.7,0.6,11.6-2.8l23.1-40.5c2-3.4,0.7-9.1-3.5-11.5s-9.7-0.6-11.7,2.8\n        l-23.1,40.5C263.8,216.9,265,222.6,269.2,225"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M147.7,225.1c4.2-2.4,5.4-8.1,3.5-11.4L128,173.3c-2-3.4-7.5-5.2-11.7-2.8\n        s-5.4,8.1-3.5,11.5l23.2,40.4C138,225.8,143.6,227.5,147.7,225.1"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M314.4,270.2c2.4,4.2,8,5.4,11.4,3.5l40.4-23.2c3.4-2,5.2-7.5,2.8-11.7\n        c-2.4-4.2-8.1-5.5-11.5-3.5l-40.4,23.2C313.8,260.4,312,266,314.4,270.2"
  }), React.createElement("polygon", {
    fill: "#FAB700",
    points: "-80,-45.5 -42,-45.5 -74.9,80.9 -50.5,80.9 -18.3,-42.9 -18.3,-65.6 -80,-65.6 \t\t\t\n        "
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M63.4-23.6h8.2l-4.1-24.6h-0.1L63.4-23.6z M50.6-4.2l11.5-61.2h11.7L85.4-4.2H74.8\n        l-1.9-11.2H62L60.3-4.2H50.6z"
  }), React.createElement("polygon", {
    fill: "#FAB700",
    points: "89.7,-65.4 113.8,-65.4 113.8,-57 100,-57 100,-39.5 110.2,-39.5 110.2,-31.2 \n        100,-31.2 100,-4.2 89.7,-4.2"
  }), React.createElement("polygon", {
    fill: "#FAB700",
    points: "118.3,-65.4 142.3,-65.4 142.3,-57 128.5,-57 128.5,-39.5 138.8,-39.5 138.8,-31.2 \n        128.5,-31.2 128.5,-4.2 118.3,-4.2"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M166.8-18.4v-32.8c0-3.7-1.6-6.3-5.3-6.3c-3.6,0-5.2,2.6-5.2,6.3v32.9\n        c0,3.7,1.6,6.3,5.2,6.3C165.2-12,166.8-14.7,166.8-18.4 M145.9-20v-29.6c0-9.6,4.7-16.5,15.5-16.5c10.9,0,15.6,7,15.6,16.5V-20\n        c0,9.5-4.7,16.5-15.6,16.5C150.6-3.5,145.9-10.5,145.9-20"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M193.2-57v19.1h3.4c3.5,0,5.1-1.8,5.1-5.1v-9c0-3.3-1.5-5-5.1-5H193.2z M193.2-32.3v28.1\n        h-10.3v-61.2h15c10.4,0,14.2,5.1,14.2,13.7v7.9c0,6.6-2.3,10.5-8.2,11.8l9.8,27.8h-10.8L193.2-32.3z"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M232.2-12.6c4.2,0,5.9-2.5,5.9-6.2v-32.1c0-3.6-1.6-6.1-5.9-6.1h-4.3v44.4H232.2z M248.4-49\n        v28.4c0,9.4-3.9,16.4-14.9,16.4h-15.9v-61.2h15.9C244.5-65.4,248.4-58.5,248.4-49z"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M264.2-23.6h8.2l-4.1-24.6h-0.1L264.2-23.6z M251.3-4.2l11.5-61.2h11.7l11.6,61.2h-10.6\n        l-1.9-11.2h-10.9l-1.8,11.2H251.3z"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M300.7-31.7v19.1h4.5c3.4,0,5.1-1.7,5.1-5v-9.2c0-3.3-1.5-5-5.1-5h-4.5V-31.7z M300.7-39.6\n        h3.6c3.3,0,4.9-1.7,4.9-5v-7.5c0-3.3-1.5-5-5-5h-3.5V-39.6z M290.4-65.4h14.9c10.3,0,13.7,4.8,13.7,13.5v6.2\n        c0,5.1-1.9,8.4-6.1,9.8c5.1,1.2,7.7,4.6,7.7,10.2v8.1c0,8.7-3.9,13.5-14.2,13.5h-16V-65.4z"
  }), React.createElement("polygon", {
    fill: "#FAB700",
    points: "325.6,-65.4 335.9,-65.4 335.9,-12.6 348.2,-12.6 348.2,-4.2 325.6,-4.2"
  }), React.createElement("polygon", {
    fill: "#FAB700",
    points: "352.9,-65.4 377.4,-65.4 377.4,-57 363.1,-57 363.1,-39.5 373.3,-39.5 373.3,-31.2 \n        363.1,-31.2 363.1,-12.6 377.4,-12.6 377.4,-4.2 352.9,-4.2"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M403.6-23.6h8.2l-4.1-24.6h-0.1L403.6-23.6z M390.7-4.2l11.6-61.2H414l11.6,61.2H415\n        l-1.9-11.2h-10.8l-1.8,11.2H390.7z"
  }), React.createElement("polygon", {
    fill: "#FAB700",
    points: "438.5,-42.7 438.5,-4.2 429.9,-4.2 429.9,-65.4 440,-65.4 451.1,-30.3 451.1,-65.4 \n        459.6,-65.4 459.6,-4.2 450.6,-4.2"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M480.1-12.6c4.2,0,5.9-2.5,5.9-6.2v-32.1c0-3.6-1.6-6.1-5.9-6.1h-4.3v44.4H480.1z M496.2-49\n        v28.4c0,9.4-3.9,16.4-14.9,16.4h-15.9v-61.2h15.9C492.4-65.4,496.2-58.5,496.2-49z"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M52.2,65.8V36.2c0-9.6,4.5-16.5,15.3-16.5C78.9,19.7,82,26,82,35.1v7.2h-9.4v-8\n        c0-3.8-1.3-6-5-6c-3.7,0-5.2,2.6-5.2,6.3v32.8c0,3.7,1.5,6.3,5.2,6.3c3.7,0,5-2.3,5-6V56.4H82V67c0,8.8-3.6,15.3-14.5,15.3\n        C56.7,82.3,52.2,75.3,52.2,65.8"
  }), React.createElement("polygon", {
    fill: "#FAB700",
    points: "87.6,20.3 97.9,20.3 97.9,73.2 110.2,73.2 110.2,81.6 87.6,81.6"
  }), React.createElement("polygon", {
    fill: "#FAB700",
    points: "114.8,20.3 139.4,20.3 139.4,28.8 125.1,28.8 125.1,46.3 135.3,46.3 135.3,54.6 \n        125.1,54.6 125.1,73.2 139.4,73.2 139.4,81.6 114.8,81.6"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M156.1,62.2h8.2l-4.1-24.6h-0.1L156.1,62.2z M143.2,81.6l11.5-61.2h11.7L178,81.6h-10.6\n        l-1.9-11.2h-10.9l-1.8,11.2H143.2z"
  }), React.createElement("polygon", {
    fill: "#FAB700",
    points: "191,43.1 191,81.6 182.4,81.6 182.4,20.4 192.5,20.4 203.6,55.5 203.6,20.4 \n        212.1,20.4 212.1,81.6 203.1,81.6"
  }), React.createElement("polygon", {
    fill: "#FAB700",
    points: "227.4,20.3 252,20.3 252,28.8 237.7,28.8 237.7,46.3 247.9,46.3 247.9,54.6 \n        237.7,54.6 237.7,73.2 252,73.2 252,81.6 227.4,81.6"
  }), React.createElement("polygon", {
    fill: "#FAB700",
    points: "266.1,43.1 266.1,81.6 257.5,81.6 257.5,20.4 267.6,20.4 278.7,55.5 278.7,20.4 \n        287.2,20.4 287.2,81.6 278.2,81.6"
  }), React.createElement("polygon", {
    fill: "#FAB700",
    points: "293.1,20.3 317.6,20.3 317.6,28.8 303.4,28.8 303.4,46.3 313.6,46.3 313.6,54.6 \n        303.4,54.6 303.4,73.2 317.6,73.2 317.6,81.6 293.1,81.6"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M333.4,28.8v19.1h3.4c3.5,0,5.1-1.8,5.1-5.1v-9c0-3.3-1.5-5-5.1-5H333.4z M333.4,53.5v28.1\n        h-10.3V20.3h15c10.4,0,14.2,5.2,14.2,13.7v7.9c0,6.6-2.3,10.5-8.2,11.8l9.8,27.8h-10.8L333.4,53.5z"
  }), React.createElement("path", {
    fill: "#FAB700",
    d: "M373.3,48.9h14.6v32.7h-7.4v-6.7c-1.4,4.6-4.2,7.4-9.8,7.4c-8.8,0-12.9-7-12.9-16.5V36.2\n        c0-9.6,4.6-16.5,15.4-16.5c11.4,0,14.7,6.3,14.7,15.4v5.4h-9.4v-6.2c0-3.8-1.4-6-5.1-6s-5.3,2.6-5.3,6.3v32.8\n        c0,3.7,1.5,6.3,5.1,6.3c3.3,0,5.1-1.9,5.1-5.9V57h-5V48.9z"
  }), React.createElement("polygon", {
    fill: "#FAB700",
    points: "411.6,58.3 411.6,81.6 401.3,81.6 401.3,58.3 389.8,20.3 400.6,20.3 406.8,43.6 \n        406.9,43.6 413.1,20.3 422.9,20.3 "
  })))));
};